<div class="start-tutorial-widget">
  <button
    class="start-tutorial-button"
    (click)="openStartDemoDialog()">
    <img class="play-icon" [src]="baseHref + 'assets/images/screencasts/play_circle_filled@2x.png'" alt="Play">
    <span>{{ label }}</span>

  </button>
</div>
